const MS_PER_DAY = 86_400_000;

const pad2 = (n: number): string => String(n).padStart(2, '0');

/**
 * Número do dia no calendário LOCAL. Contar dias pelas partes locais (e não subtraindo
 * milissegundos) evita errar "ontem" perto da meia-noite ou em dias de 23/25 horas.
 */
function localDayNumber(date: Date): number {
  return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY);
}

/** Identifica o dia local de uma data (separa as mensagens em grupos por dia). */
export function dayKey(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

/** Hora local no formato 24h ("14:05"); data inválida vira texto vazio. */
export function formatClock(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

let weekdayFormat: Intl.DateTimeFormat | undefined;
function weekdayName(date: Date): string {
  weekdayFormat ??= new Intl.DateTimeFormat('pt-BR', { weekday: 'long' });
  const name = weekdayFormat.format(date);
  return name.charAt(0).toLocaleUpperCase('pt-BR') + name.slice(1);
}

/**
 * Rótulo do separador de dia: "Hoje", "Ontem", o dia da semana até 6 dias atrás e "dd/MM/yyyy"
 * antes disso. Tudo no fuso local de quem olha. Uma data no futuro (relógio do aparelho atrasado)
 * conta como hoje, para nunca aparecer um rótulo absurdo.
 */
export function formatDayLabel(date: Date, now: Date): string {
  const daysAgo = localDayNumber(now) - localDayNumber(date);
  if (daysAgo <= 0) return 'Hoje';
  if (daysAgo === 1) return 'Ontem';
  if (daysAgo <= 6) return weekdayName(date);
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}
